"use client"

import { focalPointStyle } from "@/lib/utils"
import type { Brief } from "@/types"

interface CollabCoverImageProps {
  brief: Brief
}

// Hero zone cover art. The page-level <ShareLinkChip/> handles sharing
// (server-resolved canonical_url, no window.location fallback); no
// share button here. The rounded clip lives on an inner div so the
// construction tape can overhang the corner — it marks the whole brief
// as work-in-progress, so it renders over every cover branch.
export function CollabCoverImage({ brief }: CollabCoverImageProps) {
  return (
    <div className="relative aspect-[3/4] w-full shrink-0 lg:aspect-auto lg:w-[360px] lg:self-stretch xl:w-[420px]">
      <div className="bg-secondary size-full overflow-hidden rounded-xl">
        {brief.cover_image_url ? (
          <img
            src={brief.cover_image_url}
            alt={brief.title}
            className="size-full object-cover"
            style={focalPointStyle(brief.cover_image_focal_point)}
          />
        ) : brief.hero_prompt ? (
          <div className="flex size-full items-center justify-center p-6">
            <p className="text-tertiary text-center text-sm italic">
              {brief.hero_prompt}
            </p>
          </div>
        ) : (
          <div className="flex size-full items-center justify-center">
            <svg
              className="text-fg-quaternary size-16"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
          </div>
        )}
      </div>

      <span aria-hidden className="construction-tape">
        Under construction
      </span>
    </div>
  )
}
